"undefined" === typeof cornerstone && (cornerstone = {});
"undefined" === typeof cornerstoneWADOImageLoader && (cornerstoneWADOImageLoader = { internal: { options: { beforeSend: function(p) {} }, multiFrameCacheHack: {} } });
(function(p) {
    function c(e, c, a) { 0 === e.uint16("x00280006") ? p.convertRGBColorByPixel(c, a) : p.convertRGBColorByPlane(c, a) }
    p.convertColorSpace = function(e, f, a) {
        var g = f.uint16("x00280010"),
            b = f.uint16("x00280011"),
            d = f.string("x00280004");
        e.height = g;
        e.width = b;
        e = e.getContext("2d").createImageData(b, g);
        g = $.Deferred();
        try {
            if ("RGB" === d) c(f, a, e.data);
            else if ("YBR_RCT" === d) c(f, a, e.data);
            else if ("YBR_ICT" === d) c(f, a, e.data);
            else if ("PALETTE COLOR" === d) p.convertPALETTECOLOR(a, e.data, f);
            else if ("YBR_FULL_422" === d) p.convertYBRFull(a, e.data);
            else if ("YBR_FULL" === d) p.convertYBRFull(a, e.data);
            else throw "no color space conversion for photometric interpretation " + d;
            g.resolve(e);
            return g
        } catch (t) { return g.reject(t), g }
    }
})(cornerstoneWADOImageLoader);
(function(p) {
    p.convertPALETTECOLOR = function(c, e, f) {
        var a = f.int16("x00281101", 0),
            g = f.int16("x00281101", 1),
            b = 8 === f.int16("x00281101", 2) ? 0 : 8,
            d = f.byteArray.buffer,
            t = new Uint16Array(d, f.elements.x00281201.dataOffset, a),
            B = new Uint16Array(d, f.elements.x00281202.dataOffset, a),
            d = new Uint16Array(d, f.elements.x00281203.dataOffset, a);
        f = f.uint16("x00280010") * f.uint16("x00280011");
        for (var h = 0, q = 0, v = 0; v < f; ++v) {
            var m = c[h++],
                m = m < g ? 0 : m > g + a - 1 ? a - 1 : m - g;
            e[q++] = t[m] >> b;
            e[q++] = B[m] >> b;
            e[q++] = d[m] >> b;
            e[q++] = 255
        }
    }
})(cornerstoneWADOImageLoader);
(function(p) { p.convertRGBColorByPixel = function(c, e) { if (void 0 === c) throw "decodeRGB: rgbBuffer must not be undefined"; if (0 !== c.length % 3) throw "decodeRGB: rgbBuffer length must be divisible by 3"; for (var f = c.length / 3, a = 0, g = 0, b = 0; b < f; b++) e[g++] = c[a++], e[g++] = c[a++], e[g++] = c[a++], e[g++] = 255 } })(cornerstoneWADOImageLoader);
(function(p) {
    p.convertRGBColorByPlane = function(c, e) {
        if (void 0 === c) throw "decodeRGB: rgbBuffer must not be undefined";
        if (0 !== c.length % 3) throw "decodeRGB: rgbBuffer length must be divisible by 3";
        for (var f = c.length / 3, a = 0, g = 0; g < f; g++)
            for (var b = 0, d = f, t = 2 * f, g = 0; g < f; g++) e[a++] = c[b++], e[a++] = c[d++], e[a++] = c[t++], e[a++] = 255
    }
})(cornerstoneWADOImageLoader);
(function(p) {
    p.convertYBRFull = function(c, e) {
        if (void 0 === c) throw "decodeRGB: ybrBuffer must not be undefined";
        if (0 !== c.length % 3) throw "decodeRGB: ybrBuffer length must be divisble by 3";
        for (var f = c.length / 3, a = 0, g = 0, b = 0; b < f; b++) {
            var d = c[a++],
                t = c[a++],
                B = c[a++];
            e[g++] = d + 1.402 * (B - 128);
            e[g++] = d - .34414 * (t - 128) - .71414 * (B - 128);
            e[g++] = d + 1.772 * (t - 128);
            e[g++] = 255
        }
    }
})(cornerstoneWADOImageLoader);
(function(p) { p.configure = function(c) { p.internal.options = c } })(cornerstoneWADOImageLoader);
(function(p, c, e) {
    function f(a) {
        var g = a.indexOf(":"),
            g = a.substring(g + 1),
            b = g.indexOf("frame\x3d"),
            d; - 1 !== b && (d = g.substr(b + 6), d = parseInt(d), g = g.substr(0, b - 1));
        if (void 0 !== d && e.internal.multiFrameCacheHack.hasOwnProperty(g)) {
            var t = p.Deferred();
            e.createImageObject(e.internal.multiFrameCacheHack[g], a, d).then(function(b) { t.resolve(b) }, function(b) { t.reject(b) });
            return t
        }
        return e.internal.xhrRequest(a, d, g)
    }
    c.loadImage = f;
    c.registerImageLoader("dicomweb", f);
    c.registerImageLoader("wadouri", f)
})($, cornerstone, cornerstoneWADOImageLoader);
(function(p) { p.createImageObject = function(c, e, f) { void 0 === f && (f = 0); var a = c.string("x00280004"); return !1 === p.isColorImage(a) ? p.makeGrayscaleImage(e, c, f) : p.makeColorImage(e, c, f) } })(cornerstoneWADOImageLoader);
(function(p, c, e) {
    e.decodeJPEG2000 = function(c, a) {
        var g = c.uint16("x00280010"),
            b = c.uint16("x00280011"),
            d = dicomParser.readEncapsulatedPixelData(c, c.elements.x7fe00010, a),
            t = new JpxImage;
        t.parse(d);
        var d = t.width,
            B = t.height;
        if (d !== b) throw "JPEG2000 decoder returned width of " + d + ", when " + b + " is expected";
        if (B !== g) throw "JPEG2000 decoder returned width of " + B + ", when " + g + " is expected";
        g = t.tiles.length;
        if (1 !== g) throw "JPEG2000 decoder returned a tileCount of " + g + ", when 1 is expected";
        return t.tiles[0].items
    }
})($, cornerstone, cornerstoneWADOImageLoader);
(function(p, c, e) {
    e.decodeJPEGBaseline = function(c, a) {
        var g = c.elements.x7fe00010,
            b = c.uint16("x00280010"),
            d = c.uint16("x00280011"),
            t = c.uint16("x00280100"),
            g = dicomParser.readEncapsulatedPixelData(c, g, a),
            B = new JpegImage;
        B.parse(g);
        if (8 === t) return B.getData(d, b);
        if (16 === t) return B.getData16(d, b)
    }
})($, cornerstone, cornerstoneWADOImageLoader);
(function(p) {
    function c(c) { try { return decodeURIComponent(escape(c)) } catch (f) { if (f instanceof URIError) return c; throw f; } }
    p.decodeJPEGBaseline8Bit = function(e, f, a) {
        var g = $.Deferred(),
            b = f.uint16("x00280010"),
            d = f.uint16("x00280011");
        e.height = b;
        e.width = d;
        f = dicomParser.readEncapsulatedPixelData(f, f.elements.x7fe00010, a);
        f = new Blob([f], { type: "image/jpeg" });
        var t = new FileReader;
        void 0 === t.readAsBinaryString ? t.readAsArrayBuffer(f) : t.readAsBinaryString(f);
        t.onload = function() {
            var a = new Image;
            a.onload = function() {
                var a = e.getContext("2d");
                a.drawImage(this, 0, 0);
                a = a.getImageData(0, 0, d, b);
                g.resolve(a)
            };
            a.onerror = function(b) { g.reject(b) };
            a.src = void 0 === t.readAsBinaryString ? "data:image/jpeg;base64," + window.btoa(c(String.fromCharCode.apply(null, Array.prototype.slice.apply(new Uint8Array(t.result))))) : "data:image/jpeg;base64," + window.btoa(t.result)
        };
        return g
    };
    p.isJPEGBaseline8Bit = function(c) { var f = c.string("x00020010"); if (8 === c.uint16("x00280100") && "1.2.840.10008.1.2.4.50" === f) return !0 }
})(cornerstoneWADOImageLoader);
"use strict";
(function(p) {
    p.decodeJPEGLossless = function(c, e) {
        var f = c.elements.x7fe00010,
            a = c.uint16("x00280100"),
            g = c.uint16("x00280103"),
            f = dicomParser.readEncapsulatedPixelData(c, f, e),
            a = 8 >= a ? 1 : 2,
            f = (new jpeg.lossless.Decoder).decode(f.buffer, f.byteOffset, f.length, a);
        return 0 === g ? 2 === a ? new Uint16Array(f.buffer) : new Uint8Array(f.buffer) : new Int16Array(f.buffer)
    }
})(cornerstoneWADOImageLoader);
(function(p) {
    function c(c, f, a) {
        var g = new DataView(c.buffer, c.byteOffset),
            b = new DataView(c.buffer, c.byteOffset);
        f = new DataView(f);
        for (var d = g.getInt32(0, !0), t = 0; t < d; ++t) {
            var B = 0,
                h = 0 === t ? 1 : 0,
                q = g.getInt32(4 * (t + 1), !0),
                v = g.getInt32(4 * (t + 2), !0);
            0 === v && (v = c.length);
            for (; q < v;) {
                var m = b.getInt8(q++);
                if (0 <= m && 127 >= m)
                    for (var r = 0; r < m + 1 && B < a; ++r) f.setInt8(2 * B + h, b.getInt8(q++)), B++;
                else if (-1 >= m && -127 <= m)
                    for (var r = b.getInt8(q++), l = 0; l < -m + 1 && B < a; ++l) f.setInt8(2 * B + h, r), B++
            }
        }
    }
    p.decodeRLE = function(e, f) {
        var a = e.uint16("x00280010"),
            g = e.uint16("x00280011"),
            b = e.uint16("x00280002"),
            d = dicomParser.readEncapsulatedPixelData(e, e.elements.x7fe00010, f),
            t = p.getPixelFormat(e),
            a = g * a;
        if (1 === t) {
            for (var B = t = new ArrayBuffer(a * b), g = new DataView(d.buffer, d.byteOffset), h = new DataView(d.buffer, d.byteOffset), B = new DataView(B), q = 0, v = g.getInt32(0, !0), m = 0; m < v; ++m) {
                var q = m,
                    r = g.getInt32(4 * (m + 1), !0),
                    l = g.getInt32(4 * (m + 2), !0);
                0 === l && (l = d.length);
                for (var k = a * v; r < l;) {
                    var E = h.getInt8(r++);
                    if (0 <= E && 127 >= E)
                        for (var u = 0; u < E + 1 && q < k; ++u) B.setInt8(q, h.getInt8(r++)), q += b;
                    else if (-1 >= E && -127 <= E)
                        for (var u = h.getInt8(r++), n = 0; n < -E + 1 && q < k; ++n) B.setInt8(q, u), q += b
                }
            }
            return new Uint8Array(t)
        }
        if (2 === t) return t = new ArrayBuffer(a * b * 2), c(d, t, a), new Uint16Array(t);
        if (3 === t) return t = new ArrayBuffer(a * b * 2), c(d, t, a), new Int16Array(t)
    }
})(cornerstoneWADOImageLoader);
(function(p) { p.decodeTransferSyntax = function(c, e) { var f = c.string("x00020010"); if ("1.2.840.10008.1.2" === f || "1.2.840.10008.1.2.1" === f) return p.extractUncompressedPixels(c, e); if ("1.2.840.10008.1.2.4.90" === f || "1.2.840.10008.1.2.4.91" === f) return p.decodeJPEG2000(c, e); if ("1.2.840.10008.1.2.5" === f) return p.decodeRLE(c, e); if ("1.2.840.10008.1.2.4.50" === f || "1.2.840.10008.1.2.4.51" === f) return p.decodeJPEGBaseline(c, e); if ("1.2.840.10008.1.2.4.57" === f || "1.2.840.10008.1.2.4.70" === f) return p.decodeJPEGLossless(c, e); throw "no decoder for transfer syntax " + f; } })(cornerstoneWADOImageLoader);
var ColorSpace = { Unkown: 0, Grayscale: 1, AdobeRGB: 2, RGB: 3, CYMK: 4 },
    JpegImage = function() {
        function p() {}

        function c(b, d) {
            for (var g = 0, a = [], c, e, f = 16; 0 < f && !b[f - 1];) f--;
            a.push({ children: [], index: 0 });
            var m = a[0],
                r;
            for (c = 0; c < f; c++) {
                for (e = 0; e < b[c]; e++) {
                    m = a.pop();
                    for (m.children[m.index] = d[g]; 0 < m.index;) m = a.pop();
                    m.index++;
                    for (a.push(m); a.length <= c;) a.push(r = { children: [], index: 0 }), m.children[m.index] = r.children, m = r;
                    g++
                }
                c + 1 < f && (a.push(r = { children: [], index: 0 }), m.children[m.index] = r.children, m = r)
            }
            return a[0].children
        }

        function e(b, d, a, c, h, e, f, m, r) {
            function l() {
                if (0 < I) return I--, x >> I & 1;
                x = b[d++];
                if (255 == x) { var a = b[d++]; if (a) throw "unexpected marker: " + (x << 8 | a).toString(16); }
                I = 7;
                return x >>> 7
            }

            function k(b) { for (var d; null !== (d = l());) { b = b[d]; if ("number" === typeof b) return b; if ("object" !== typeof b) throw "invalid huffman sequence"; } return null }

            function p(b) {
                for (var d = 0; 0 < b;) {
                    var a = l();
                    if (null === a) return;
                    d = d << 1 | a;
                    b--
                }
                return d
            }

            function u(b) { var d = p(b); return d >= 1 << b - 1 ? d : d + (-1 << b) + 1 }

            function n(b, d) {
                var a = k(b.huffmanTableDC),
                    a = 0 === a ? 0 : u(a);
                b.blockData[d] = b.pred += a;
                for (a = 1; 64 > a;) {
                    var t = k(b.huffmanTableAC),
                        c = t & 15,
                        t = t >> 4;
                    if (0 === c) {
                        if (15 > t) break;
                        a += 16
                    } else a += t, b.blockData[d + g[a]] = u(c), a++
                }
            }

            function A(b, d) {
                var a = k(b.huffmanTableDC),
                    a = 0 === a ? 0 : u(a) << r;
                b.blockData[d] = b.pred += a
            }

            function z(b, a) { b.blockData[a] |= l() << r }

            function y(b, a) {
                if (0 < J) J--;
                else
                    for (var d = e; d <= f;) {
                        var t = k(b.huffmanTableAC),
                            c = t & 15,
                            t = t >> 4;
                        if (0 === c) {
                            if (15 > t) { J = p(t) + (1 << t) - 1; break }
                            d += 16
                        } else d += t, b.blockData[a + g[d]] = u(c) * (1 << r), d++
                    }
            }

            function D(b, d) {
                for (var a = e, t = 0; a <= f;) {
                    var c = g[a];
                    switch (G) {
                        case 0:
                            t = k(b.huffmanTableAC);
                            c = t & 15;
                            t >>= 4;
                            if (0 === c) 15 > t ? (J = p(t) + (1 << t), G = 4) : (t = 16, G = 1);
                            else {
                                if (1 !== c) throw "invalid ACn encoding";
                                P = u(c);
                                G = t ? 2 : 3
                            }
                            continue;
                        case 1:
                        case 2:
                            b.blockData[d + c] ? b.blockData[d + c] += l() << r : (t--, 0 === t && (G = 2 == G ? 3 : 0));
                            break;
                        case 3:
                            b.blockData[d + c] ? b.blockData[d + c] += l() << r : (b.blockData[d + c] = P << r, G = 0);
                            break;
                        case 4:
                            b.blockData[d + c] && (b.blockData[d + c] += l() << r)
                    }
                    a++
                }
                4 === G && (J--, 0 === J && (G = 0))
            }
            var C = a.mcusPerLine,
                w = d,
                x = 0,
                I = 0,
                J = 0,
                G = 0,
                P, M = c.length,
                F, H, N, O, L;
            m = a.progressive ? 0 === e ? 0 === m ? A : z : 0 === m ? y : D : n;
            var K = 0;
            a = 1 == M ? c[0].blocksPerLine * c[0].blocksPerColumn : C * a.mcusPerColumn;
            h || (h = a);
            for (var Q, R; K < a;) {
                for (H = 0; H < M; H++) c[H].pred = 0;
                J = 0;
                if (1 == M)
                    for (F = c[0], L = 0; L < h; L++) m(F, 64 * ((F.blocksPerLine + 1) * (K / F.blocksPerLine | 0) + K % F.blocksPerLine)), K++;
                else
                    for (L = 0; L < h; L++) {
                        for (H = 0; H < M; H++)
                            for (F = c[H], Q = F.h, R = F.v, N = 0; N < R; N++)
                                for (O = 0; O < Q; O++) m(F, 64 * ((F.blocksPerLine + 1) * ((K / C | 0) * F.v + N) + (K % C * F.h + O)));
                        K++
                    }
                I = 0;
                F = b[d] << 8 | b[d + 1];
                if (65280 >= F) throw "marker was not found";
                if (65488 <= F && 65495 >= F) d += 2;
                else break
            }
            return d - w
        }

        function f(b, d) {
            for (var a = d.blocksPerLine, g = d.blocksPerColumn, c = new Int32Array(64), e = 0; e < g; e++)
                for (var f = 0; f < a; f++) { for (var m = d, r = 64 * ((d.blocksPerLine + 1) * e + f), l = c, k = m.quantizationTable, p = void 0, u = void 0, n = void 0, A = void 0, z = void 0, y = void 0, D = void 0, C = void 0, w = void 0, x = void 0, x = 0; 64 > x; x++) l[x] = m.blockData[r + x] * k[x]; for (x = 0; 8 > x; ++x) k = 8 * x, 0 === l[1 + k] && 0 === l[2 + k] && 0 === l[3 + k] && 0 === l[4 + k] && 0 === l[5 + k] && 0 === l[6 + k] && 0 === l[7 + k] ? (w = 5793 * l[0 + k] + 512 >> 10, l[0 + k] = w, l[1 + k] = w, l[2 + k] = w, l[3 + k] = w, l[4 + k] = w, l[5 + k] = w, l[6 + k] = w, l[7 + k] = w) : (p = 5793 * l[0 + k] + 128 >> 8, u = 5793 * l[4 + k] + 128 >> 8, n = l[2 + k], A = l[6 + k], z = 2896 * (l[1 + k] - l[7 + k]) + 128 >> 8, C = 2896 * (l[1 + k] + l[7 + k]) + 128 >> 8, y = l[3 + k] << 4, D = l[5 + k] << 4, w = p - u + 1 >> 1, p = p + u + 1 >> 1, u = w, w = 3784 * n + 1567 * A + 128 >> 8, n = 1567 * n - 3784 * A + 128 >> 8, A = w, w = z - D + 1 >> 1, z = z + D + 1 >> 1, D = w, w = C + y + 1 >> 1, y = C - y + 1 >> 1, C = w, w = p - A + 1 >> 1, p = p + A + 1 >> 1, A = w, w = u - n + 1 >> 1, u = u + n + 1 >> 1, n = w, w = 2276 * z + 3406 * C + 2048 >> 12, z = 3406 * z - 2276 * C + 2048 >> 12, C = w, w = 799 * y + 4017 * D + 2048 >> 12, y = 4017 * y - 799 * D + 2048 >> 12, D = w, l[0 + k] = p + C, l[7 + k] = p - C, l[1 + k] = u + D, l[6 + k] = u - D, l[2 + k] = n + y, l[5 + k] = n - y, l[3 + k] = A + z, l[4 + k] = A - z); for (x = 0; 8 > x; ++x) k = x, 0 === l[8 + k] && 0 === l[16 + k] && 0 === l[24 + k] && 0 === l[32 + k] && 0 === l[40 + k] && 0 === l[48 + k] && 0 === l[56 + k] ? (w = 5793 * l[x + 0] + 8192 >> 14, l[0 + k] = w, l[8 + k] = w, l[16 + k] = w, l[24 + k] = w, l[32 + k] = w, l[40 + k] = w, l[48 + k] = w, l[56 + k] = w) : (p = 5793 * l[0 + k] + 2048 >> 12, u = 5793 * l[32 + k] + 2048 >> 12, n = l[16 + k], A = l[48 + k], z = 2896 * (l[8 + k] - l[56 + k]) + 2048 >> 12, C = 2896 * (l[8 + k] + l[56 + k]) + 2048 >> 12, y = l[24 + k], D = l[40 + k], w = p - u + 1 >> 1, p = p + u + 1 >> 1, u = w, w = 3784 * n + 1567 * A + 2048 >> 12, n = 1567 * n - 3784 * A + 2048 >> 12, A = w, w = z - D + 1 >> 1, z = z + D + 1 >> 1, D = w, w = C + y + 1 >> 1, y = C - y + 1 >> 1, C = w, w = p - A + 1 >> 1, p = p + A + 1 >> 1, A = w, w = u - n + 1 >> 1, u = u + n + 1 >> 1, n = w, w = 2276 * z + 3406 * C + 2048 >> 12, z = 3406 * z - 2276 * C + 2048 >> 12, C = w, w = 799 * y + 4017 * D + 2048 >> 12, y = 4017 * y - 799 * D + 2048 >> 12, D = w, l[0 + k] = p + C, l[56 + k] = p - C, l[8 + k] = u + D, l[48 + k] = u - D, l[16 + k] = n + y, l[40 + k] = n - y, l[24 + k] = A + z, l[32 + k] = A - z); for (x = 0; 64 > x; ++x) p = r + x, u = l[x], u = u <= -2056 / m.bitConversion ? 0 : u >= 2024 / m.bitConversion ? 255 / m.bitConversion : u + 2056 / m.bitConversion >> 4, m.blockData[p] = u }
            return d.blockData
        }

        function a(b) { return 0 >= b ? 0 : 255 <= b ? 255 : b | 0 }
        var g = new Int32Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]);
        p.prototype = {
            load: function(b) {
                var d = function(b) { this.parse(b); if (this.onload) this.onload() }.bind(this);
                if (-1 < b.indexOf("data:")) {
                    var a = b.indexOf("base64,") + 7;
                    b = atob(b.substring(a));
                    for (var a = new Uint8Array(b.length), g = b.length - 1; 0 <= g; g--) a[g] = b.charCodeAt(g);
                    d(b)
                } else {
                    var c = new XMLHttpRequest;
                    c.open("GET", b, !0);
                    c.responseType = "arraybuffer";
                    c.onload = function() {
                        var b = new Uint8Array(c.response);
                        d(b)
                    }.bind(this);
                    c.send(null)
                }
            },
            parse: function(b) {
                function d() {
                    var a = b[h] << 8 | b[h + 1];
                    h += 2;
                    return a
                }

                function a() {
                    var g = d(),
                        g = b.subarray(h, h + g - 2);
                    h += g.length;
                    return g
                }

                function B(b) {
                    for (var a = Math.ceil(b.samplesPerLine / 8 / b.maxH), d = Math.ceil(b.scanLines / 8 / b.maxV), g = 0; g < b.components.length; g++) {
                        x = b.components[g];
                        var c = Math.ceil(Math.ceil(b.samplesPerLine / 8) * x.h / b.maxH),
                            t = Math.ceil(Math.ceil(b.scanLines / 8) * x.v / b.maxV);
                        x.blockData = new Int16Array(64 * d * x.v * (a * x.h + 1));
                        x.blocksPerLine = c;
                        x.blocksPerColumn = t
                    }
                    b.mcusPerLine = a;
                    b.mcusPerColumn = d
                }
                var h = 0,
                    q = null,
                    p = null,
                    m, r, l = [],
                    k = [],
                    E = [],
                    u = d();
                if (65496 != u) throw "SOI not found";
                for (u = d(); 65497 != u;) {
                    var n, A;
                    switch (u) {
                        case 65504:
                        case 65505:
                        case 65506:
                        case 65507:
                        case 65508:
                        case 65509:
                        case 65510:
                        case 65511:
                        case 65512:
                        case 65513:
                        case 65514:
                        case 65515:
                        case 65516:
                        case 65517:
                        case 65518:
                        case 65519:
                        case 65534:
                            n = a();
                            65504 === u && 74 === n[0] && 70 === n[1] && 73 === n[2] && 70 === n[3] && 0 === n[4] && (q = { version: { major: n[5], minor: n[6] }, densityUnits: n[7], xDensity: n[8] << 8 | n[9], yDensity: n[10] << 8 | n[11], thumbWidth: n[12], thumbHeight: n[13], thumbData: n.subarray(14, 14 + 3 * n[12] * n[13]) });
                            65518 === u && 65 === n[0] && 100 === n[1] && 111 === n[2] && 98 === n[3] && 101 === n[4] && 0 === n[5] && (p = { version: n[6], flags0: n[7] << 8 | n[8], flags1: n[9] << 8 | n[10], transformCode: n[11] });
                            break;
                        case 65499:
                            for (u = d() + h - 2; h < u;) {
                                var z = b[h++],
                                    y = new Int32Array(64);
                                if (0 === z >> 4)
                                    for (n = 0; 64 > n; n++) y[g[n]] = b[h++];
                                else if (1 === z >> 4)
                                    for (n = 0; 64 > n; n++) y[g[n]] = d();
                                else throw "DQT: invalid table spec";
                                l[z & 15] = y
                            }
                            break;
                        case 65472:
                        case 65473:
                        case 65474:
                            if (m) throw "Only single frame JPEGs supported";
                            d();
                            m = {};
                            m.extended = 65473 === u;
                            m.progressive = 65474 === u;
                            m.precision = b[h++];
                            m.scanLines = d();
                            m.samplesPerLine = d();
                            m.components = [];
                            m.componentIds = {};
                            n = b[h++];
                            for (var D = y = 0, u = 0; u < n; u++) {
                                z = b[h];
                                A = b[h + 1] >> 4;
                                var C = b[h + 1] & 15;
                                y < A && (y = A);
                                D < C && (D = C);
                                var w = b[h + 2];
                                A = m.components.push({ h: A, v: C, quantizationTable: l[w], quantizationTableId: w, bitConversion: 255 / ((1 << m.precision) - 1) });
                                m.componentIds[z] = A - 1;
                                h += 3
                            }
                            m.maxH = y;
                            m.maxV = D;
                            B(m);
                            break;
                        case 65476:
                            z = d();
                            for (u = 2; u < z;) {
                                y = b[h++];
                                D = new Uint8Array(16);
                                for (n = A = 0; 16 > n; n++, h++) A += D[n] = b[h];
                                C = new Uint8Array(A);
                                for (n = 0; n < A; n++, h++) C[n] = b[h];
                                u += 17 + A;
                                (0 === y >> 4 ? E : k)[y & 15] = c(D, C)
                            }
                            break;
                        case 65501:
                            d();
                            r = d();
                            break;
                        case 65498:
                            d();
                            z = b[h++];
                            n = [];
                            for (var x, u = 0; u < z; u++) y = m.componentIds[b[h++]], x = m.components[y], y = b[h++], x.huffmanTableDC = E[y >> 4], x.huffmanTableAC = k[y & 15], n.push(x);
                            u = b[h++];
                            z = b[h++];
                            y = b[h++];
                            u = e(b, h, m, n, r, u, z, y >> 4, y & 15);
                            h += u;
                            break;
                        default:
                            if (255 == b[h - 3] && 192 <= b[h - 2] && 254 >= b[h - 2]) { h -= 3; break }
                            throw "unknown JPEG marker " + u.toString(16);
                    }
                    u = d()
                }
                this.width = m.samplesPerLine;
                this.height = m.scanLines;
                this.jfif = q;
                this.adobe = p;
                this.components = [];
                switch (m.components.length) {
                    case 1:
                        this.colorspace = ColorSpace.Grayscale;
                        break;
                    case 3:
                        this.colorspace = this.adobe ? ColorSpace.AdobeRGB : ColorSpace.RGB;
                        break;
                    case 4:
                        this.colorspace = ColorSpace.CYMK;
                        break;
                    default:
                        this.colorspace = ColorSpace.Unknown
                }
                for (u = 0; u < m.components.length; u++) x = m.components[u], x.quantizationTable || null === x.quantizationTableId || (x.quantizationTable = l[x.quantizationTableId]), this.components.push({ output: f(m, x), scaleX: x.h / m.maxH, scaleY: x.v / m.maxV, blocksPerLine: x.blocksPerLine, blocksPerColumn: x.blocksPerColumn, bitConversion: x.bitConversion })
            },
            getData16: function(b, a) {
                if (1 !== this.components.length) throw "Unsupported color mode";
                var g = this.width / b,
                    c = this.height / a,
                    h, e, f, m, r, l = 0,
                    k = this.components.length,
                    p = new Uint16Array(b * a * k),
                    u = new Uint16Array((this.components[0].blocksPerLine << 3) * this.components[0].blocksPerColumn * 8);
                for (r = 0; r < k; r++) {
                    h = this.components[r];
                    e = h.blocksPerLine;
                    f = h.blocksPerColumn;
                    for (var n = e << 3, A, z = 0, y = 0; y < f; y++)
                        for (var D = y << 3, C = 0; C < e; C++) {
                            var w = 64 * ((h.blocksPerLine + 1) * y + C),
                                l = 0,
                                x = C << 3;
                            for (m = 0; 8 > m; m++)
                                for (z = (D + m) * n, A = 0; 8 > A; A++) u[z + x + A] = h.output[w + l++]
                        }
                    e = h.scaleX * g;
                    h = h.scaleY * c;
                    l = r;
                    for (m = 0; m < a; m++)
                        for (f = 0; f < b; f++) z = 0 | m * h, A = 0 | f * e, A = z * n + A, p[l] = u[A], l += k
                }
                return p
            },
            getData: function(b, d) {
                var g = this.width / b,
                    c = this.height / d,
                    h, e, f, m, r, l = 0,
                    k, p = this.components.length,
                    u = b * d * p,
                    n = new Uint8Array(u);
                k = new Uint8Array((this.components[0].blocksPerLine << 3) * this.components[0].blocksPerColumn * 8);
                for (r = 0; r < p; r++) {
                    h = this.components[r];
                    e = h.blocksPerLine;
                    f = h.blocksPerColumn;
                    for (var A = e << 3, z, y = 0, D = 0; D < f; D++)
                        for (var C = D << 3, w = 0; w < e; w++) {
                            var x = 64 * ((h.blocksPerLine + 1) * D + w),
                                l = 0,
                                I = w << 3;
                            for (m = 0; 8 > m; m++)
                                for (y = (C + m) * A, z = 0; 8 > z; z++) k[y + I + z] = h.output[x + l++] * h.bitConversion
                        }
                    e = h.scaleX * g;
                    h = h.scaleY * c;
                    l = r;
                    for (m = 0; m < d; m++)
                        for (f = 0; f < b; f++) y = 0 | m * h, z = 0 | f * e, z = y * A + z, n[l] = k[z], l += p
                }
                switch (p) {
                    case 1:
                    case 2:
                        break;
                    case 3:
                        r = !0;
                        this.adobe && this.adobe.transformCode ? r = !0 : "undefined" !== typeof this.colorTransform && (r = !!this.colorTransform);
                        if (r)
                            for (r = 0; r < u; r += p) g = n[r], c = n[r + 1], k = n[r + 2], l = a(g - 179.456 + 1.402 * k), k = a(g + 135.459 - .344 * c - .714 * k), g = a(g - 226.816 + 1.772 * c), n[r] = l, n[r + 1] = k, n[r + 2] = g;
                        break;
                    case 4:
                        if (!this.adobe) throw "Unsupported color mode (4 components)";
                        r = !1;
                        this.adobe && this.adobe.transformCode ? r = !0 : "undefined" !== typeof this.colorTransform && (r = !!this.colorTransform);
                        if (r)
                            for (r = 0; r < u; r += p) g = n[r], c = n[r + 1], k = n[r + 2], l = a(434.456 - g - 1.402 * k), k = a(119.541 - g + .344 * c + .714 * k), g = a(481.816 - g - 1.772 * c), n[r] = l, n[r + 1] = k, n[r + 2] = g;
                        break;
                    default:
                        throw "Unsupported color mode";
                }
                return n
            }
        };
        return p
    }();
(function(p) { "object" === typeof exports && "undefined" !== typeof module ? module.exports = p() : "function" === typeof define && define.amd ? define([], p) : ("undefined" !== typeof window ? window : "undefined" !== typeof global ? global : "undefined" !== typeof self ? self : this).jpeg = p() })(function() {
    return function c(e, f, a) {
        function g(d, B) {
            if (!f[d]) {
                if (!e[d]) {
                    var h = "function" == typeof require && require;
                    if (!B && h) return h(d, !0);
                    if (b) return b(d, !0);
                    h = Error("Cannot find module '" + d + "'");
                    throw h.code = "MODULE_NOT_FOUND", h;
                }
                h = f[d] = { exports: {} };
                e[d][0].call(h.exports, function(b) { var a = e[d][1][b]; return g(a ? a : b) }, h, h.exports, c, e, f, a)
            }
            return f[d].exports
        }
        for (var b = "function" == typeof require && require, d = 0; d < a.length; d++) g(a[d]);
        return g
    }({
        1: [function(c, e, f) {
            var a = a || {};
            a.lossless = a.lossless || {};
            a.lossless.ComponentSpec = a.lossless.ComponentSpec || function() { this.vSamp = this.quantTableSel = this.hSamp = 0 };
            "undefined" !== typeof e && e.exports && (e.exports = a.lossless.ComponentSpec)
        }, {}],
        2: [function(c, e, f) {
            var a = a || {};
            a.lossless = a.lossless || {};
            a.lossless.DataStream = a.lossless.DataStream || function(a, b, d) {
                this.buffer = new DataView(a, b, d);
                this.index = 0
            };
            a.lossless.DataStream.prototype.get16 = function() {
                var a = this.buffer.getUint16(this.index, !1);
                this.index += 2;
                return a
            };
            a.lossless.DataStream.prototype.get8 = function() {
                var a = this.buffer.getUint8(this.index);
                this.index += 1;
                return a
            };
            "undefined" !== typeof e && e.exports && (e.exports = a.lossless.DataStream)
        }, {}],
        3: [function(c, e, f) {
            var a = a || {};
            a.lossless = a.lossless || {};
            a.lossless.DataStream = a.lossless.DataStream || ("undefined" !== typeof c ? c("./data-stream.js") : null);
            a.lossless.HuffmanTable = a.lossless.HuffmanTable || ("undefined" !== typeof c ? c("./huffman-table.js") : null);
            a.lossless.QuantizationTable = a.lossless.QuantizationTable || ("undefined" !== typeof c ? c("./quantization-table.js") : null);
            a.lossless.ScanHeader = a.lossless.ScanHeader || ("undefined" !== typeof c ? c("./scan-header.js") : null);
            a.lossless.FrameHeader = a.lossless.FrameHeader || ("undefined" !== typeof c ? c("./frame-header.js") : null);
            a.lossless.Utils = a.lossless.Utils || ("undefined" !== typeof c ? c("./utils.js") : null);
            a.lossless.Decoder = a.lossless.Decoder || function(g, b) {
                this.buffer = g;
                this.frame = new a.lossless.FrameHeader;
                this.huffTable = new a.lossless.HuffmanTable;
                this.quantTable = new a.lossless.QuantizationTable;
                this.scan = new a.lossless.ScanHeader;
                this.DU = a.lossless.Utils.createArray(10, 4, 64);
                this.HuffTab = a.lossless.Utils.createArray(4, 2, 12800);
                this.IDCT_Source = [];
                this.nBlock = [];
                this.acTab = a.lossless.Utils.createArray(10, 1);
                this.dcTab = a.lossless.Utils.createArray(10, 1);
                this.qTab = a.lossless.Utils.createArray(10, 1);
                this.yLoc = this.xLoc = this.yDim = this.xDim = this.selection = this.restartInterval = this.numComp = this.markerIndex = this.marker = 0;
                this.outputData = null;
                this.numBytes = "undefined" === typeof b ? 2 : b
            };
            a.lossless.Decoder.IDCT_P = [0, 5, 40, 16, 45, 2, 7, 42, 21, 56, 8, 61, 18, 47, 1, 4, 41, 23, 58, 13, 32, 24, 37, 10, 63, 17, 44, 3, 6, 43, 20, 57, 15, 34, 29, 48, 53, 26, 39, 9, 60, 19, 46, 22, 59, 12, 33, 31, 50, 55, 25, 36, 11, 62, 14, 35, 28, 49, 52, 27, 38, 30, 51, 54];
            a.lossless.Decoder.TABLE = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63];
            a.lossless.Decoder.MAX_HUFFMAN_SUBTREE = 50;
            a.lossless.Decoder.MSB = 2147483648;
            a.lossless.Decoder.prototype.decode = function(g, b, d, c) {
                var e = 0,
                    h = [],
                    f = [],
                    v = [];
                "undefined" !== typeof g && (this.buffer = g);
                "undefined" !== typeof c && (this.numBytes = c);
                2 === this.numBytes ? (this.getter = this.getValue16, this.setter = this.setValue16) : 1 === this.numBytes && (this.getter = this.getValue8, this.setter = this.setValue8);
                this.stream = new a.lossless.DataStream(this.buffer, b, d);
                this.buffer = null;
                this.yLoc = this.xLoc = 0;
                g = this.stream.get16();
                if (65496 !== g) throw Error("Not a JPEG file");
                for (g = this.stream.get16(); 4092 !== g >> 4 || 65476 === g;) {
                    switch (g) {
                        case 65476:
                            this.huffTable.read(this.stream, this.HuffTab);
                            break;
                        case 65484:
                            throw Error("Program doesn't support arithmetic coding. (format throw new IOException)");
                        case 65499:
                            this.quantTable.read(this.stream, a.lossless.Decoder.TABLE);
                            break;
                        case 65501:
                            this.restartInterval = this.readNumber();
                            break;
                        case 65504:
                        case 65505:
                        case 65506:
                        case 65507:
                        case 65508:
                        case 65509:
                        case 65510:
                        case 65511:
                        case 65512:
                        case 65513:
                        case 65514:
                        case 65515:
                        case 65516:
                        case 65517:
                        case 65518:
                        case 65519:
                            this.readApp();
                            break;
                        case 65534:
                            this.readComment();
                            break;
                        default:
                            if (255 !== g >> 8) throw Error("ERROR: format throw new IOException! (decode)");
                    }
                    g = this.stream.get16()
                }
                if (65472 > g || 65479 < g) throw Error("ERROR: could not handle arithmetic code!");
                this.frame.read(this.stream);
                g = this.stream.get16();
                do {
                    for (; 65498 !== g;) {
                        switch (g) {
                            case 65476:
                                this.huffTable.read(this.stream, this.HuffTab);
                                break;
                            case 65484:
                                throw Error("Program doesn't support arithmetic coding. (format throw new IOException)");
                            case 65499:
                                this.quantTable.read(this.stream, a.lossless.Decoder.TABLE);
                                break;
                            case 65501:
                                this.restartInterval = this.readNumber();
                                break;
                            case 65504:
                            case 65505:
                            case 65506:
                            case 65507:
                            case 65508:
                            case 65509:
                            case 65510:
                            case 65511:
                            case 65512:
                            case 65513:
                            case 65514:
                            case 65515:
                            case 65516:
                            case 65517:
                            case 65518:
                            case 65519:
                                this.readApp();
                                break;
                            case 65534:
                                this.readComment();
                                break;
                            default:
                                if (255 !== g >> 8) throw Error("ERROR: format throw new IOException! (Parser.decode)");
                        }
                        g = this.stream.get16()
                    }
                    this.precision = this.frame.precision;
                    this.components = this.frame.components;
                    this.scan.read(this.stream);
                    this.numComp = this.scan.numComp;
                    this.selection = this.scan.selection;
                    this.scanComps = this.scan.components;
                    this.quantTables = this.quantTable.quantTables;
                    for (b = 0; b < this.numComp; b += 1) d = this.scanComps[b].scanCompSel, this.qTab[b] = this.quantTables[this.components[d].quantTableSel], this.nBlock[b] = this.components[d].vSamp * this.components[d].hSamp, this.dcTab[b] = this.HuffTab[this.scanComps[b].dcTabSel][0], this.acTab[b] = this.HuffTab[this.scanComps[b].acTabSel][1];
                    this.xDim = this.frame.dimX;
                    this.yDim = this.frame.dimY;
                    this.outputData = new DataView(new ArrayBuffer(this.xDim * this.yDim * this.numBytes));
                    for (e += 1;;) {
                        f[0] = 0;
                        for (b = v[0] = 0; 10 > b; b += 1) h[b] = 1 << this.precision - 1;
                        if (0 === this.restartInterval) { for (g = this.decodeUnit(h, f, v); 0 === g && this.xLoc < this.xDim && this.yLoc < this.yDim;) this.output(h), g = this.decodeUnit(h, f, v); break }
                        for (b = 0; b < this.restartInterval && (g = this.decodeUnit(h, f, v), this.output(h), 0 === g); b += 1);
                        0 === g && (0 !== this.markerIndex ? (g = 65280 | this.marker, this.markerIndex = 0) : g = this.stream.get16());
                        if (!(65488 <= g && 65495 >= g)) break
                    }
                    65500 === g && 1 === e && (this.readNumber(), g = this.stream.get16())
                } while (65497 !== g && this.xLoc < this.xDim && this.yLoc < this.yDim && 0 === e);
                return this.outputData
            };
            a.lossless.Decoder.prototype.decodeUnit = function(g, b, d) {
                var c, e, h, f, v, m, r;
                switch (this.selection) {
                    case 2:
                        g[0] = this.getPreviousY();
                        break;
                    case 3:
                        g[0] = this.getPreviousXY();
                        break;
                    case 4:
                        g[0] = this.getPreviousX() + this.getPreviousY() - this.getPreviousXY();
                        break;
                    case 5:
                        g[0] = this.getPreviousX() + (this.getPreviousY() - this.getPreviousXY() >> 1);
                        break;
                    case 6:
                        g[0] = this.getPreviousY() + (this.getPreviousX() - this.getPreviousXY() >> 1);
                        break;
                    case 7:
                        g[0] = (this.getPreviousX() + this.getPreviousY()) / 2;
                        break;
                    default:
                        g[0] = this.getPreviousX()
                }
                if (1 < this.numComp)
                    for (v = 0; v < this.numComp; v += 1)
                        for (f = this.qTab[v], e = this.acTab[v], h = this.dcTab[v], m = 0; m < this.nBlock[v]; m += 1) {
                            for (c = 0; c < this.IDCT_Source.length; c += 1) this.IDCT_Source[c] = 0;
                            c = this.getHuffmanValue(h, b, d);
                            if (65280 <= c) return c;
                            g[v] = this.IDCT_Source[0] = g[v] + this.getn(d, c, b, d);
                            this.IDCT_Source[0] *= f[0];
                            for (r = 1; 64 > r; r += 1) {
                                c = this.getHuffmanValue(e, b, d);
                                if (65280 <= c) return c;
                                r += c >> 4;
                                if (0 === (c & 15)) { if (0 === c >> 4) break } else this.IDCT_Source[a.lossless.Decoder.IDCT_P[r]] = this.getn(d, c & 15, b, d) * f[r]
                            }
                            this.scaleIDCT(this.DU[v][m])
                        } else
                            for (m = 0; m < this.nBlock[0]; m += 1) {
                                c = this.getHuffmanValue(this.dcTab[0], b, d);
                                if (65280 <= c) return c;
                                g[0] += this.getn(g, c, b, d)
                            }
                return 0
            };
            a.lossless.Decoder.prototype.getHuffmanValue = function(g, b, d) {
                var c, e;
                8 > d[0] ? (b[0] <<= 8, e = this.stream.get8(), 255 === e && (this.marker = this.stream.get8(), 0 !== this.marker && (this.markerIndex = 9)), b[0] |= e) : d[0] -= 8;
                c = g[b[0] >> d[0]];
                if (0 !== (c & a.lossless.Decoder.MSB)) {
                    if (0 !== this.markerIndex) return this.markerIndex = 0, 65280 | this.marker;
                    b[0] &= 65535 >> 16 - d[0];
                    b[0] <<= 8;
                    e = this.stream.get8();
                    255 === e && (this.marker = this.stream.get8(), 0 !== this.marker && (this.markerIndex = 9));
                    b[0] |= e;
                    c = g[256 * (c & 255) + (b[0] >> d[0])];
                    d[0] += 8
                }
                d[0] += 8 - (c >> 8);
                if (0 > d[0]) throw Error("index\x3d" + d[0] + " temp\x3d" + b[0] + " code\x3d" + c + " in HuffmanValue()");
                if (d[0] < this.markerIndex) return this.markerIndex = 0, 65280 | this.marker;
                b[0] &= 65535 >> 16 - d[0];
                return c & 255
            };
            a.lossless.Decoder.prototype.getn = function(a, b, d, c) {
                if (0 === b) return 0;
                if (16 === b) return 0 <= a[0] ? -32768 : 32768;
                c[0] -= b;
                if (0 <= c[0]) { if (c[0] < this.markerIndex && !this.isLastPixel()) return this.markerIndex = 0, (65280 | this.marker) << 8 } else {
                    d[0] <<= 8;
                    a = this.stream.get8();
                    255 === a && (this.marker = this.stream.get8(), 0 !== this.marker && (this.markerIndex = 9));
                    d[0] |= a;
                    c[0] += 8;
                    if (0 > c[0]) {
                        if (0 !== this.markerIndex) return this.markerIndex = 0, (65280 | this.marker) << 8;
                        d[0] <<= 8;
                        a = this.stream.get8();
                        255 === a && (this.marker = this.stream.get8(), 0 !== this.marker && (this.markerIndex = 9));
                        d[0] |= a;
                        c[0] += 8
                    }
                    if (0 > c[0]) throw Error("index\x3d" + c[0] + " in getn()");
                    if (c[0] < this.markerIndex) return this.markerIndex = 0, (65280 | this.marker) << 8
                }
                a = d[0] >> c[0];
                d[0] &= 65535 >> 16 - c[0];
                a < 1 << b - 1 && (a += (-1 << b) + 1);
                return a
            };
            a.lossless.Decoder.prototype.getPreviousX = function() { return 0 < this.xLoc ? this.getter(this.yLoc * this.xDim + this.xLoc - 1) : 0 < this.yLoc ? this.getPreviousY() : 1 << this.frame.precision - 1 };
            a.lossless.Decoder.prototype.getPreviousXY = function() { return 0 < this.xLoc && 0 < this.yLoc ? this.getter((this.yLoc - 1) * this.xDim + this.xLoc - 1) : this.getPreviousY() };
            a.lossless.Decoder.prototype.getPreviousY = function() { return 0 < this.yLoc ? this.getter((this.yLoc - 1) * this.xDim + this.xLoc) : this.getPreviousX() };
            a.lossless.Decoder.prototype.isLastPixel = function() { return this.xLoc === this.xDim - 1 && this.yLoc === this.yDim - 1 };
            a.lossless.Decoder.prototype.output = function(a) { this.xLoc < this.xDim && this.yLoc < this.yDim && (this.setter(this.yLoc * this.xDim + this.xLoc, a[0]), this.xLoc += 1, this.xLoc >= this.xDim && (this.yLoc += 1, this.xLoc = 0)) };
            a.lossless.Decoder.prototype.setValue16 = function(a, b) { this.outputData.setInt16(2 * a, b, !0) };
            a.lossless.Decoder.prototype.getValue16 = function(a) { return this.outputData.getInt16(2 * a, !0) };
            a.lossless.Decoder.prototype.setValue8 = function(a, b) { this.outputData.setInt8(a, b) };
            a.lossless.Decoder.prototype.getValue8 = function(a) { return this.outputData.getInt8(a) };
            a.lossless.Decoder.prototype.readApp = function() { for (var a = 0, b = this.stream.get16(), a = a + 2; a < b;) this.stream.get8(), a += 1; return b };
            a.lossless.Decoder.prototype.readComment = function() {
                var a = "",
                    b = 0,
                    d;
                d = this.stream.get16();
                for (b += 2; b < d;) a += this.stream.get8(), b += 1;
                return a
            };
            a.lossless.Decoder.prototype.readNumber = function() { if (4 !== this.stream.get16()) throw Error("ERROR: Define number format throw new IOException [Ld!\x3d4]"); return this.stream.get16() };
            a.lossless.Decoder.prototype.scaleIDCT = function(c) {
                var b = a.lossless.Utils.createArray(8, 8),
                    d, e, f, h, q, v, m, r, l, k, E, u, n = 0;
                for (q = 0; 8 > q; q += 1) f = this.IDCT_Source[0 + q], h = this.IDCT_Source[8 + q], v = this.IDCT_Source[16 + q] - this.IDCT_Source[24 + q], m = this.IDCT_Source[24 + q] + this.IDCT_Source[16 + q], r = this.IDCT_Source[32 + q] - this.IDCT_Source[56 + q], k = this.IDCT_Source[40 + q] - this.IDCT_Source[48 + q], d = this.IDCT_Source[40 + q] + this.IDCT_Source[48 + q], e = this.IDCT_Source[32 + q] + this.IDCT_Source[56 + q], l = d - e, E = d + e, u = 480 * -r - 192 * k, l *= 384, k = 480 * k - 192 * r, E *= 256, d = 256 * f, e = 256 * h, f = 384 * v, r = h = 256 * m, m = d + e, d -= e, e = f - h, f = m + r, h = d + e, v = d - e, m -= r, r = k - u - l - E, l = l - k + E, k -= E, b[0][q] = f + E + 4096 >> 13, b[1][q] = h + k + 4096 >> 13, b[2][q] = v + l + 4096 >> 13, b[3][q] = m + r + 4096 >> 13, b[4][q] = m - r + 4096 >> 13, b[5][q] = v - l + 4096 >> 13, b[6][q] = h - k + 4096 >> 13, b[7][q] = f - E + 4096 >> 13;
                for (q = 0; 8 > q; q += 1) f = b[q][0], h = b[q][1], v = b[q][2] - b[q][3], m = b[q][3] + b[q][2], r = b[q][4] - b[q][7], k = b[q][5] - b[q][6], d = b[q][5] + b[q][6], e = b[q][4] + b[q][7], l = d - e, E = d + e, u = 480 * -r - 192 * k, l *= 384, k = 480 * k - 192 * r, E *= 256, d = 256 * f, e = 256 * h, f = 384 * v, r = h = 256 * m, m = d + e, d -= e, e = f - h, f = m + r, h = d + e, v = d - e, m -= r, r = k - u - l - E, l = l - k + E, k -= E, c[n += 1] = f + E + 4096 >> 13, c[n += 1] = h + k + 4096 >> 13, c[n += 1] = v + l + 4096 >> 13, c[n += 1] = m + r + 4096 >> 13, c[n += 1] = m - r + 4096 >> 13, c[n += 1] = v - l + 4096 >> 13, c[n += 1] = h - k + 4096 >> 13, c[n += 1] = f - E + 4096 >> 13
            };
            "undefined" !== typeof e && e.exports && (e.exports = a.lossless.Decoder)
        }, { "./data-stream.js": 2, "./frame-header.js": 4, "./huffman-table.js": 5, "./quantization-table.js": 7, "./scan-header.js": 9, "./utils.js": 10 }],
        4: [function(c, e, f) {
            var a = a || {};
            a.lossless = a.lossless || {};
            a.lossless.ComponentSpec = a.lossless.ComponentSpec || ("undefined" !== typeof c ? c("./component-spec.js") : null);
            a.lossless.DataStream = a.lossless.DataStream || ("undefined" !== typeof c ? c("./data-stream.js") : null);
            a.lossless.FrameHeader = a.lossless.FrameHeader || function() {
                this.components = [];
                this.precision = this.numComp = this.dimY = this.dimX = 0
            };
            a.lossless.FrameHeader.prototype.read = function(c) {
                var b = 0,
                    d, e, f, h;
                d = c.get16();
                b += 2;
                this.precision = c.get8();
                b += 1;
                this.dimY = c.get16();
                b += 2;
                this.dimX = c.get16();
                b += 2;
                this.numComp = c.get8();
                b += 1;
                for (e = 1; e <= this.numComp; e += 1) {
                    if (b > d) throw Error("ERROR: frame format error");
                    f = c.get8();
                    b += 1;
                    if (b >= d) throw Error("ERROR: frame format error [c\x3e\x3dLf]");
                    h = c.get8();
                    b += 1;
                    this.components[f] || (this.components[f] = new a.lossless.ComponentSpec);
                    this.components[f].hSamp = h >> 4;
                    this.components[f].vSamp = h & 15;
                    this.components[f].quantTableSel = c.get8();
                    b += 1
                }
                if (b !== d) throw Error("ERROR: frame format error [Lf!\x3dcount]");
                return 1
            };
            "undefined" !== typeof e && e.exports && (e.exports = a.lossless.FrameHeader)
        }, { "./component-spec.js": 1, "./data-stream.js": 2 }],
        5: [function(c, e, f) {
            var a = a || {};
            a.lossless = a.lossless || {};
            a.lossless.DataStream = a.lossless.DataStream || ("undefined" !== typeof c ? c("./data-stream.js") : null);
            a.lossless.Utils = a.lossless.Utils || ("undefined" !== typeof c ? c("./utils.js") : null);
            a.lossless.HuffmanTable = a.lossless.HuffmanTable || function() {
                this.l = a.lossless.Utils.createArray(4, 2, 16);
                this.th = [];
                this.v = a.lossless.Utils.createArray(4, 2, 16, 200);
                this.tc = a.lossless.Utils.createArray(4, 2);
                this.tc[0][0] = 0;
                this.tc[1][0] = 0;
                this.tc[2][0] = 0;
                this.tc[3][0] = 0;
                this.tc[0][1] = 0;
                this.tc[1][1] = 0;
                this.tc[2][1] = 0;
                this.tc[3][1] = 0;
                this.th[0] = 0;
                this.th[1] = 0;
                this.th[2] = 0;
                this.th[3] = 0
            };
            a.lossless.HuffmanTable.MSB = 2147483648;
            a.lossless.HuffmanTable.prototype.read = function(a, b) {
                var d = 0,
                    c, e, f, q, v;
                c = a.get16();
                for (d += 2; d < c;) {
                    e = a.get8();
                    d += 1;
                    f = e & 15;
                    if (3 < f) throw Error("ERROR: Huffman table ID \x3e 3");
                    e >>= 4;
                    if (2 < e) throw Error("ERROR: Huffman table [Table class \x3e 2 ]");
                    this.th[f] = 1;
                    this.tc[f][e] = 1;
                    for (q = 0; 16 > q; q += 1) this.l[f][e][q] = a.get8(), d += 1;
                    for (q = 0; 16 > q; q += 1)
                        for (v = 0; v < this.l[f][e][q]; v += 1) {
                            if (d > c) throw Error("ERROR: Huffman table format error [count\x3eLh]");
                            this.v[f][e][q][v] = a.get8();
                            d += 1
                        }
                }
                if (d !== c) throw Error("ERROR: Huffman table format error [count!\x3dLf]");
                for (q = 0; 4 > q; q += 1)
                    for (v = 0; 2 > v; v += 1) 0 !== this.tc[q][v] && this.buildHuffTable(b[q][v], this.l[q][v], this.v[q][v]);
                return 1
            };
            a.lossless.HuffmanTable.prototype.buildHuffTable = function(c, b, d) {
                var e, f, h, q, v;
                for (h = f = 0; 8 > h; h += 1)
                    for (q = 0; q < b[h]; q += 1)
                        for (v = 0; v < 256 >> h + 1; v += 1) c[f] = d[h][q] | h + 1 << 8, f += 1;
                for (h = 1; 256 > f; h += 1, f += 1) c[f] = h | a.lossless.HuffmanTable.MSB;
                e = 1;
                f = 0;
                for (h = 8; 16 > h; h += 1)
                    for (q = 0; q < b[h]; q += 1) {
                        for (v = 0; v < 256 >> h - 7; v += 1) c[256 * e + f] = d[h][q] | h + 1 << 8, f += 1;
                        if (256 <= f) {
                            if (256 < f) throw Error("ERROR: Huffman table error(1)!");
                            f = 0;
                            e += 1
                        }
                    }
            };
            "undefined" !== typeof e && e.exports && (e.exports = a.lossless.HuffmanTable)
        }, { "./data-stream.js": 2, "./utils.js": 10 }],
        6: [function(c, e, f) {
            var a = a || {};
            a.lossless = a.lossless || {};
            a.lossless.ComponentSpec = a.lossless.ComponentSpec || ("undefined" !== typeof c ? c("./component-spec.js") : null);
            a.lossless.DataStream = a.lossless.DataStream || ("undefined" !== typeof c ? c("./data-stream.js") : null);
            a.lossless.Decoder = a.lossless.Decoder || ("undefined" !== typeof c ? c("./decoder.js") : null);
            a.lossless.FrameHeader = a.lossless.FrameHeader || ("undefined" !== typeof c ? c("./frame-header.js") : null);
            a.lossless.HuffmanTable = a.lossless.HuffmanTable || ("undefined" !== typeof c ? c("./huffman-table.js") : null);
            a.lossless.QuantizationTable = a.lossless.QuantizationTable || ("undefined" !== typeof c ? c("./quantization-table.js") : null);
            a.lossless.ScanComponent = a.lossless.ScanComponent || ("undefined" !== typeof c ? c("./scan-component.js") : null);
            a.lossless.ScanHeader = a.lossless.ScanHeader || ("undefined" !== typeof c ? c("./scan-header.js") : null);
            a.lossless.Utils = a.lossless.Utils || ("undefined" !== typeof c ? c("./utils.js") : null);
            "undefined" !== typeof e && e.exports && (e.exports = a)
        }, { "./component-spec.js": 1, "./data-stream.js": 2, "./decoder.js": 3, "./frame-header.js": 4, "./huffman-table.js": 5, "./quantization-table.js": 7, "./scan-component.js": 8, "./scan-header.js": 9, "./utils.js": 10 }],
        7: [function(c, e, f) {
            var a = a || {};
            a.lossless = a.lossless || {};
            a.lossless.DataStream = a.lossless.DataStream || ("undefined" !== typeof c ? c("./data-stream.js") : null);
            a.lossless.Utils = a.lossless.Utils || ("undefined" !== typeof c ? c("./utils.js") : null);
            a.lossless.QuantizationTable = a.lossless.QuantizationTable || function() {
                this.precision = [];
                this.tq = [];
                this.quantTables = a.lossless.Utils.createArray(4, 64);
                this.tq[0] = 0;
                this.tq[1] = 0;
                this.tq[2] = 0;
                this.tq[3] = 0
            };
            a.lossless.QuantizationTable.enhanceQuantizationTable = function(a, b) { var d; for (d = 0; 8 > d; d += 1) a[b[0 + d]] *= 90, a[b[32 + d]] *= 90, a[b[16 + d]] *= 118, a[b[48 + d]] *= 49, a[b[40 + d]] *= 71, a[b[8 + d]] *= 126, a[b[56 + d]] *= 25, a[b[24 + d]] *= 106; for (d = 0; 8 > d; d += 1) a[b[0 + 8 * d]] *= 90, a[b[4 + 8 * d]] *= 90, a[b[2 + 8 * d]] *= 118, a[b[6 + 8 * d]] *= 49, a[b[5 + 8 * d]] *= 71, a[b[1 + 8 * d]] *= 126, a[b[7 + 8 * d]] *= 25, a[b[3 + 8 * d]] *= 106; for (d = 0; 64 > d; d += 1) a[d] >>= 6 };
            a.lossless.QuantizationTable.prototype.read = function(c, b) {
                var d = 0,
                    e, f, h;
                e = c.get16();
                for (d += 2; d < e;) {
                    f = c.get8();
                    d += 1;
                    h = f & 15;
                    if (3 < h) throw Error("ERROR: Quantization table ID \x3e 3");
                    this.precision[h] = f >> 4;
                    if (0 === this.precision[h]) this.precision[h] = 8;
                    else if (1 === this.precision[h]) this.precision[h] = 16;
                    else throw Error("ERROR: Quantization table precision error");
                    this.tq[h] = 1;
                    if (8 === this.precision[h])
                        for (f = 0; 64 > f; f += 1) {
                            if (d > e) throw Error("ERROR: Quantization table format error");
                            this.quantTables[h][f] = c.get8();
                            d += 1
                        } else
                            for (f = 0; 64 > f; f += 1) {
                                if (d > e) throw Error("ERROR: Quantization table format error");
                                this.quantTables[h][f] = c.get16();
                                d += 2
                            }
                    a.lossless.QuantizationTable.enhanceQuantizationTable(this.quantTables[h], b)
                }
                if (d !== e) throw Error("ERROR: Quantization table error [count!\x3dLq]");
                return 1
            };
            "undefined" !== typeof e && e.exports && (e.exports = a.lossless.QuantizationTable)
        }, { "./data-stream.js": 2, "./utils.js": 10 }],
        8: [function(c, e, f) {
            var a = a || {};
            a.lossless = a.lossless || {};
            a.lossless.ScanComponent = a.lossless.ScanComponent || function() { this.scanCompSel = this.dcTabSel = this.acTabSel = 0 };
            "undefined" !== typeof e && e.exports && (e.exports = a.lossless.ScanComponent)
        }, {}],
        9: [function(c, e, f) {
            var a = a || {};
            a.lossless = a.lossless || {};
            a.lossless.DataStream = a.lossless.DataStream || ("undefined" !== typeof c ? c("./data-stream.js") : null);
            a.lossless.ScanComponent = a.lossless.ScanComponent || ("undefined" !== typeof c ? c("./scan-component.js") : null);
            a.lossless.ScanHeader = a.lossless.ScanHeader || function() {
                this.spectralEnd = this.selection = this.numComp = this.al = this.ah = 0;
                this.components = []
            };
            a.lossless.ScanHeader.prototype.read = function(c) {
                var b = 0,
                    d, e, f;
                d = c.get16();
                b += 2;
                this.numComp = c.get8();
                b += 1;
                for (e = 0; e < this.numComp; e += 1) {
                    this.components[e] = new a.lossless.ScanComponent;
                    if (b > d) throw Error("ERROR: scan header format error");
                    this.components[e].scanCompSel = c.get8();
                    b += 1;
                    f = c.get8();
                    b += 1;
                    this.components[e].dcTabSel = f >> 4;
                    this.components[e].acTabSel = f & 15
                }
                this.selection = c.get8();
                b += 1;
                this.spectralEnd = c.get8();
                b += 1;
                f = c.get8();
                this.ah = f >> 4;
                this.al = f & 15;
                if (b + 1 !== d) throw Error("ERROR: scan header format error [count!\x3dNs]");
                return 1
            };
            "undefined" !== typeof e && e.exports && (e.exports = a.lossless.ScanHeader)
        }, { "./data-stream.js": 2, "./scan-component.js": 8 }],
        10: [function(c, e, f) {
            var a = a || {};
            a.lossless = a.lossless || {};
            a.lossless.Utils = a.lossless.Utils || {};
            a.lossless.Utils.createArray = function(c) {
                var b = Array(c || 0),
                    d = c;
                if (1 < arguments.length)
                    for (var e = Array.prototype.slice.call(arguments, 1); d--;) b[c - 1 - d] = a.lossless.Utils.createArray.apply(this, e);
                return b
            };
            "undefined" !== typeof e && e.exports && (e.exports = a.lossless.Utils)
        }, {}]
    }, {}, [6])(6)
});
(function(p, c, e) {
    e.extractUncompressedPixels = function(c, a) {
        var g = e.getPixelFormat(c),
            b = c.elements.x7fe00010,
            d = c.uint16("x00280010"),
            p = c.uint16("x00280011"),
            B = c.uint16("x00280002"),
            b = b.dataOffset,
            d = p * d * B;
        if (1 === g) return new Uint8Array(c.byteArray.buffer, b + a * d, d);
        if (2 === g) return new Uint16Array(c.byteArray.buffer, b + a * d * 2, d);
        if (3 === g) return new Int16Array(c.byteArray.buffer, b + a * d * 2, d)
    }
})($, cornerstone, cornerstoneWADOImageLoader);
(function(p) {
    p.getPixelFormat = function(c) {
        var e = c.uint16("x00280103");
        c = c.uint16("x00280100");
        if (0 === e && 8 === c) return 1;
        if (0 === e && 16 === c) return 2;
        if (1 === e && 16 === c) return 3
    }
})(cornerstoneWADOImageLoader);
(function(p) { p.getPixelSpacing = function(c) { return (c = c.string("x00280030")) && 0 < c.length ? (c = c.split("\\"), { row: parseFloat(c[0]), column: parseFloat(c[1]) }) : { row: void 0, column: void 0 } } })(cornerstoneWADOImageLoader);
(function(p) {
    p.getRescaleSlopeAndIntercept = function(c) {
        var e = { intercept: 0, slope: 1 },
            f = c.floatString("x00281052");
        c = c.floatString("x00281053");
        f && c && (e.intercept = f, e.slope = c);
        return e
    }
})(cornerstoneWADOImageLoader);
(function(p) {
    p.getWindowWidthAndCenter = function(c) {
        var e = { windowCenter: void 0, windowWidth: void 0 },
            f = c.floatString("x00281050");
        c = c.floatString("x00281051");
        f && c && (e.windowCenter = f, e.windowWidth = c);
        return e
    }
})(cornerstoneWADOImageLoader);
(function(p) { p.isColorImage = function(c) { return "RGB" === c || "PALETTE COLOR" === c || "YBR_FULL" === c || "YBR_FULL_422" === c || "YBR_PARTIAL_422" === c || "YBR_PARTIAL_420" === c || "YBR_RCT" === c || "YBR_ICT" === c ? !0 : !1 } })(cornerstoneWADOImageLoader);
(function(p, c, e) {
    function f(b, c) { if (!0 === e.isJPEGBaseline8Bit(b)) return e.decodeJPEGBaseline8Bit(a, b, c); var f = e.decodeTransferSyntax(b, c); return e.convertColorSpace(a, b, f) }
    var a = document.createElement("canvas"),
        g = "";
    e.makeColorImage = function(b, d, t) {
        var B = e.getPixelSpacing(d),
            h = d.uint16("x00280010"),
            q = d.uint16("x00280011"),
            v = d.uint16("x00200032"),
            m = e.getRescaleSlopeAndIntercept(d),
            r = h * q * 4,
            l = e.getWindowWidthAndCenter(d);
        g = void 0;
        var k = p.Deferred(),
            E;
        try { E = f(d, t) } catch (u) { return k.reject(u), k }
        E.then(function(e) {
            var f = {
                imageId: b,
                minPixelValue: 0,
                maxPixelValue: 255,
                slope: m.slope,
                intercept: m.intercept,
                windowCenter: l.windowCenter,
                windowWidth: l.windowWidth,
                render: c.renderColorImage,
                getPixelData: function() { return e.data },
                getImageData: function() { return e },
                getCanvas: function() {
                    if (g === b) return a;
                    a.height = h;
                    a.width = q;
                    a.getContext("2d").putImageData(e, 0, 0);
                    g = b;
                    return a
                },
                rows: h,
                columns: q,
                height: h,
                width: q,
                color: !0,
                columnPixelSpacing: B.column,
                rowPixelSpacing: B.row,
                data: d,
                invert: !1,
                sizeInBytes: r,
                imagePositionPatient: v
            };
            void 0 === f.windowCenter && (f.windowWidth = 255, f.windowCenter = 128);
            k.resolve(f)
        }, function(a) { k.reject(a) });
        return k
    }
})($, cornerstone, cornerstoneWADOImageLoader);
(function(p, c, e) {
    function f(a) { a = e.getPixelFormat(a); if (1 === a) return 1; if (2 === a || 3 === a) return 2; throw "unknown pixel format"; }

    function a(a) {
        for (var b = 65535, c = -32768, e = a.length, f = 0; f < e; f++) var h = a[f],
            b = Math.min(b, h),
            c = Math.max(c, h);
        return { min: b, max: c }
    }
    e.makeGrayscaleImage = function(g, b, d) {
        var t = p.Deferred(),
            B = e.getPixelSpacing(b),
            h = b.uint16("x00280010"),
            q = b.uint16("x00280011"),
            v = b.uint16("x00200032"),
            m = e.getRescaleSlopeAndIntercept(b),
            r;
        try { r = f(b) } catch (l) { return t.reject(l), t }
        r *= h * q;
        var k = "MONOCHROME1" === b.string("x00280004"),
            E = e.getWindowWidthAndCenter(b),
            u;
        try { u = e.decodeTransferSyntax(b, d) } catch (n) { return t.reject(n), t }
        d = a(u);
        g = { imageId: g, minPixelValue: d.min, maxPixelValue: d.max, slope: m.slope, intercept: m.intercept, windowCenter: E.windowCenter, windowWidth: E.windowWidth, render: c.renderGrayscaleImage, getPixelData: function() { return u }, rows: h, columns: q, height: h, width: q, color: !1, columnPixelSpacing: B.column, rowPixelSpacing: B.row, data: b, invert: k, sizeInBytes: r, imagePositionPatient: v };
        void 0 === g.windowCenter && (b = g.maxPixelValue * g.slope + g.intercept, B = g.minPixelValue * g.slope + g.intercept, g.windowWidth = b - B, g.windowCenter = (b + B) / 2);
        t.resolve(g);
        return t
    }
})($, cornerstone, cornerstoneWADOImageLoader);
(function(p) { p.version = "0.7.0" })(cornerstoneWADOImageLoader);
(function(p, c, e) {
    e.internal.xhrRequest = function(f, a, g) {
        var b = p.Deferred(),
            d = new XMLHttpRequest;
        d.responseType = "arraybuffer";
        g = window.location.protocol + g;
        g = g.replace(window.location.origin + '/', domainName)
        d.open("get", g, !0);
        e.internal.options.beforeSend(d);
        d.onreadystatechange = function(c) { 4 === d.readyState && (200 === d.status ? (c = new Uint8Array(d.response), c = dicomParser.parseDicom(c), void 0 !== a && (e.internal.multiFrameCacheHack[g] = c), e.createImageObject(c, f, a).then(function(a) { b.resolve(a) }, function(a) { b.reject(a) })) : b.reject(d.response)) };
        d.onprogress = function(a) {
            if (a.lengthComputable) {
                var b = a.loaded;
                a = a.total;
                var d = Math.round(b / a * 100);
                p(c).trigger("CornerstoneImageLoadProgress", { imageId: f, loaded: b, total: a, percentComplete: d })
            }
        };
        d.send();
        return b
    }
})($, cornerstone, cornerstoneWADOImageLoader);
1